/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Hero_TitleInputs */

const en_mk_hero_title = /** @type {(inputs: Mk_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projects, team chat, and AI agents. One workspace.`)
};

const id_mk_hero_title = /** @type {(inputs: Mk_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyek, chat tim, dan agen AI. Satu ruang kerja.`)
};

/**
* | output |
* | --- |
* | "Projects, team chat, and AI agents. One workspace." |
*
* @param {Mk_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_hero_title = /** @type {((inputs?: Mk_Hero_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Hero_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_hero_title(inputs)
	return en_mk_hero_title(inputs)
});